import React from "react";
import { Link } from "gatsby";

import styles from "../assets/styles/NetworkNavigation.module.scss";

const NetworkNavigation = ({ trail }) => {
	const links = trail.map(item => (
		<li key={item.title} className={styles.item}>
			<Link to={item.to}>{item.title}</Link>
		</li>
	));

	return (
		<div className={styles.root}>
			<Link to="/" className={styles.logo} />
			<ul className={styles.nav}>{links}</ul>
		</div>
	);
};

export default NetworkNavigation;
